import React from 'react';
export function Header() {
  return <div className="bg-gradient-to-r from-teal-700 to-blue-900 text-white p-8 rounded-2xl shadow-2xl mb-6" data-id="element-296">
      <h1 className="text-4xl font-bold mb-3 drop-shadow-md" data-id="element-297">
        Dr. Richard Tan's Balance Method
      </h1>
      <p className="text-xl opacity-90 font-light" data-id="element-298">
        Complete Clinical Reference & Treatment Guide
      </p>
    </div>;
}